export default "__VITE_ASSET__Baiwz4qw__"